function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { createContext, forwardRef, useState, useImperativeHandle, useMemo, useRef, useEffect, useCallback, useContext } from 'react';
import { Flyout } from '@els/els-react--flyout';
import { Icon } from '@els/els-react--icon';
import { createEnum, generateId, useEventListener, ValidPropTypes, makeErrorBoundComponent } from '@els/els-react--utils';
import classnames from 'classnames';
import PT from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
var DefaultMessages = createEnum({
  label: 'Tabs',
  toggleLabel: 'Open/close tab list'
});
var arrayOf = PT.arrayOf,
  bool = PT.bool,
  func = PT.func,
  node = PT.node,
  number = PT.number,
  object = PT.object,
  oneOfType = PT.oneOfType,
  shape = PT.shape,
  string = PT.string;
var Elements = createContext({
  activeTab: "0",
  setActiveTab: function setActiveTab() {
    return void 0;
  },
  tabsId: "",
  tabKeys: []
});
var Tab = function Tab(_ref) {
  var name = _ref.name,
    secondary = _ref.secondary,
    tabId = _ref.tabId,
    closeFlyout = _ref.closeFlyout,
    setTabWidth = _ref.setTabWidth,
    isControlled = _ref.isControlled,
    isDisabled = _ref.isDisabled,
    isOverflow = _ref.isOverflow,
    onTabChange = _ref.onTabChange;
  if (secondary) {
    console.warn("Secondary is deprecated, use another style instead");
  }
  var _useContext = useContext(Elements),
    tabsId = _useContext.tabsId,
    activeTab = _useContext.activeTab,
    setActiveTab = _useContext.setActiveTab;
  var buttonClasses = isOverflow ? classnames("u-els-anchorize", "c-els-link", "u-els-margin-bottom-1o2", "c-els-tab-group__collapsed-item", {
    "c-els-link--disabled": isDisabled
  }) : classnames("c-els-tab-group__text", "c-els-tab-group__item", {
    // DEPRECATED: this isn't a style in the DBG
    "c-els-tab-group__text--secondary": secondary && tabId !== activeTab,
    "c-els-tab-group__item--active": tabId === activeTab,
    "c-els-tab-group__item--disabled": isDisabled
  });
  var buttonRef = useRef();
  var tabIndex = !isOverflow && tabId !== activeTab ? "-1" : null;
  useEffect(function () {
    var _buttonRef$current, _document;
    var adjustForButtonPadding = isOverflow ? 32 : 0;
    setTabWidth(_defineProperty({}, tabId, buttonRef.current.clientWidth + adjustForButtonPadding));
    var thisTabIsActive = tabId === activeTab;
    var focusIsOnThisTabGroup = ((_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 ? void 0 : _buttonRef$current.parentNode) === ((_document = document) === null || _document === void 0 || (_document = _document.activeElement) === null || _document === void 0 ? void 0 : _document.parentNode);
    if (thisTabIsActive && focusIsOnThisTabGroup) {
      buttonRef.current.focus();
    }
  }, [tabId, activeTab]);
  var handleOnClick = function handleOnClick() {
    isOverflow && closeFlyout && closeFlyout();
    if (onTabChange) {
      onTabChange(tabId);
    }
    if (!isControlled) {
      setActiveTab(tabId);
    }
  };
  return (
    // W3C recommends using a button element as the tab, and not using list elements
    /* @__PURE__ */
    React.createElement("button", {
      className: buttonClasses,
      ref: buttonRef,
      onClick: handleOnClick,
      tabIndex: tabIndex,
      disabled: isDisabled,
      type: "button",
      role: "tab",
      "aria-controls": "tabpanel-".concat(tabsId, "-").concat(tabId),
      "aria-selected": tabId === activeTab,
      id: "tab-".concat(tabsId, "-").concat(tabId)
    }, name)
  );
};
var TabList = function TabList(_ref2) {
  var className = _ref2.className,
    hasDivider = _ref2.hasDivider,
    id = _ref2.id,
    isControlled = _ref2.isControlled,
    messages = _ref2.messages,
    noDropdown = _ref2.noDropdown,
    secondary = _ref2.secondary,
    tabListRef = _ref2.tabListRef,
    onTabChange = _ref2.onTabChange;
  var compiledMessages = _objectSpread(_objectSpread({}, DefaultMessages), messages);
  var _useContext2 = useContext(Elements),
    disabledTabs = _useContext2.disabledTabs,
    tabs = _useContext2.tabNames,
    tabsId = _useContext2.tabsId,
    tabKeys = _useContext2.tabKeys,
    activeTab = _useContext2.activeTab;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    tabsWidth = _useState2[0],
    setTabWidth = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOverflow = _useState4[0],
    setIsOverflow = _useState4[1];
  var flyoutRef = useRef();
  var buttonRef = useRef();
  var buttonClasses = classnames("c-els-tab-group__text", "u-els-anchorize",
  // DEPRECATED: this isn't a style in the DBG
  {
    "c-els-tab-group__text--secondary": secondary
  });
  var handleSetWidth = function handleSetWidth(tab) {
    setTabWidth(function (prev) {
      return _objectSpread(_objectSpread({}, prev), tab);
    });
  };
  var calculateSize = useCallback(function () {
    var _tabListRef$current;
    if (noDropdown) return;
    var elementsWidth = Object.values(tabsWidth).reduce(function (total, width) {
      return total + width;
    }, 0);
    setIsOverflow(elementsWidth > (tabListRef === null || tabListRef === void 0 || (_tabListRef$current = tabListRef.current) === null || _tabListRef$current === void 0 ? void 0 : _tabListRef$current.clientWidth));
  }, [noDropdown, tabsWidth, tabListRef]);
  useEffect(function () {
    window.addEventListener("resize", calculateSize);
    setTimeout(calculateSize, 1);
    return function () {
      window.removeEventListener("resize", calculateSize);
    };
  });
  var closeFlyout = function closeFlyout() {
    flyoutRef.current.toggleVisibility(false);
  };
  var renderTabs = function renderTabs() {
    return tabs.map(function (tab, i) {
      return /* @__PURE__ */React.createElement(Tab, {
        name: tab,
        secondary: secondary,
        key: tabKeys[i],
        tabId: "".concat(i),
        closeFlyout: closeFlyout,
        setTabWidth: handleSetWidth,
        isControlled: isControlled,
        isDisabled: disabledTabs.includes(i),
        isOverflow: isOverflow,
        onTabChange: onTabChange
      });
    });
  };
  return /* @__PURE__ */React.createElement("div", {
    className: classnames("c-els-tab-group", className, {
      "dropdown-container": isOverflow,
      "c-els-tab-group__divider": hasDivider
    }),
    "data-testid": "tab-group",
    id: id,
    role: "tablist",
    "aria-label": compiledMessages.LABEL,
    ref: tabListRef
  }, isOverflow ? /* @__PURE__ */React.createElement("div", {
    className: "c-els-tab-group__item c-els-tab-group__item--collapsed",
    id: "".concat(tabsId, "-tab-flyout")
  }, /* @__PURE__ */React.createElement(Flyout, {
    shouldCloseOnESC: true,
    id: "".concat(tabsId, "-flyout"),
    placement: "bottom-start",
    flyout: renderTabs(),
    ref: flyoutRef
  }, /* @__PURE__ */React.createElement("button", {
    className: buttonClasses,
    ref: buttonRef,
    type: "button"
  }, tabs[activeTab], /* @__PURE__ */React.createElement(Icon, {
    className: "tab-group__button__icon",
    sprite: Icon.Sprites.CHEVRON_DOWN,
    size: "xs",
    textAlignment: Icon.TextAlignment.OFFSET,
    fallback: (/* istanbul ignore next */
    function fallback() {
      return "▼";
    })
  }, compiledMessages.TOGGLE_LABEL)))) : renderTabs());
};
var PanelList = function PanelList(_ref3) {
  var children = _ref3.children;
  return React.Children.map(children, function (child, index) {
    return React.cloneElement(child, {
      panelId: "".concat(index)
    });
  });
};
var TabPanel = function TabPanel(_ref4) {
  var children = _ref4.children,
    panelId = _ref4.panelId;
  var _useContext3 = useContext(Elements),
    tabsId = _useContext3.tabsId,
    activeTab = _useContext3.activeTab;
  var isActive = activeTab === panelId;
  return isActive ? /* @__PURE__ */React.createElement("div", {
    className: "c-els-tab-group__panel",
    id: "tabpanel-".concat(tabsId, "-").concat(panelId),
    "aria-labelledby": "tab-".concat(tabsId, "-").concat(panelId),
    role: "tabpanel",
    tabIndex: "0"
  }, children) : null;
};
var TabGroup = forwardRef(function (_ref5, ref) {
  var children = _ref5.children,
    className = _ref5.className,
    hasDivider = _ref5.hasDivider,
    disabledTabs = _ref5.disabledTabs,
    id = _ref5.id,
    isControlled = _ref5.isControlled,
    messages = _ref5.messages,
    noDropdown = _ref5.noDropdown,
    onTabChange = _ref5.onTabChange,
    secondary = _ref5.secondary,
    tabs = _ref5.tabs,
    useAnchor = _ref5.useAnchor;
  var _useState5 = useState("0"),
    _useState6 = _slicedToArray(_useState5, 2),
    activeTab = _useState6[0],
    _setActiveTab = _useState6[1];
  var _useState7 = useState(generateId()),
    _useState8 = _slicedToArray(_useState7, 1),
    tabsId = _useState8[0];
  var _useState9 = useState(Array.from({
      length: tabs.length
    }, function () {
      return generateId();
    })),
    _useState10 = _slicedToArray(_useState9, 1),
    tabKeys = _useState10[0];
  useImperativeHandle(ref, function () {
    return {
      // function to set the active tab
      // TODO could add a console.warn and quietly fail if the index is out of range (as per Paginator use of useImperativeHandle)
      setActiveTab: function setActiveTab(index) {
        _setActiveTab("".concat(index));
      },
      // the current tab
      getActiveTab: function getActiveTab() {
        return parseInt(activeTab, 10);
      },
      // function to go to whatever tab is next, or the first tab if at the end
      nextTab: function nextTab() {
        var index = (parseInt(activeTab, 10) + 1) % tabs.length;
        _setActiveTab("".concat(index));
      },
      // function to go to whatever tab is previous, or the last tab if at the start
      prevTab: function prevTab() {
        var index = (parseInt(activeTab, 10) - 1 + tabs.length) % tabs.length;
        _setActiveTab("".concat(index));
      }
    };
  }, [activeTab, _setActiveTab]);
  var elements = useMemo(function () {
    return {
      activeTab: activeTab,
      disabledTabs: disabledTabs,
      tabNames: tabs,
      setActiveTab: _setActiveTab,
      tabsId: tabsId,
      tabKeys: tabKeys
    };
  }, [activeTab, disabledTabs, tabKeys, tabs, tabsId]);
  var tabListRef = useRef();
  var initialLoadRef = useRef(false);
  useEffect(function () {
    if (useAnchor) {
      var hashIndex = decodeURI(window.location.hash.substring(1).split("tab-")[1]);
      if (hashIndex >= 0) {
        _setActiveTab(hashIndex);
      }
    }
  }, [tabs, useAnchor]);
  useEffect(function () {
    if (initialLoadRef.current && useAnchor) {
      window.location.hash = "#tab-".concat(activeTab);
    } else {
      initialLoadRef.current = true;
    }
  }, [activeTab, useAnchor]);
  var handler = useCallback(function (e) {
    e.stopPropagation();
    var isTab = e.target.classList.contains("c-els-tab-group__text");
    if (!isTab || !["Home", "End", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Up", "Down", "Left", "Right"].includes(e.key)) return;
    e.preventDefault();
    var index = +activeTab;
    if (["Home"].includes(e.key)) {
      index = 0;
    }
    if (["End"].includes(e.key)) {
      index = tabs.length - 1;
    }
    if (["ArrowUp", "Up"].includes(e.key)) {
      index += 1;
    }
    if (["ArrowDown", "Down"].includes(e.key)) {
      index -= 1;
    }
    if (["ArrowLeft", "Left"].includes(e.key)) {
      index -= 1;
    }
    if (["ArrowRight", "Right"].includes(e.key)) {
      index += 1;
    }
    index += elements.tabNames.length;
    index %= elements.tabNames.length;
    if (onTabChange) {
      onTabChange("".concat(index));
    }
    if (!isControlled) {
      _setActiveTab("".concat(index));
    }
  }, [activeTab, elements.tabNames.length, isControlled, onTabChange, tabs.length]);
  useEventListener("keydown", handler, tabListRef.current);
  return /* @__PURE__ */React.createElement(Elements.Provider, {
    value: elements
  }, /* @__PURE__ */React.createElement(TabList, {
    className: className,
    hasDivider: hasDivider,
    id: id,
    isControlled: isControlled,
    messages: messages,
    secondary: secondary,
    tabListRef: tabListRef,
    noDropdown: noDropdown,
    onTabChange: onTabChange
  }), /* @__PURE__ */React.createElement(PanelList, null, children));
});
TabPanel.displayName = "TabPanel";
TabPanel.propTypes = {
  children: node.isRequired,
  panelId: string
};
TabPanel.requiredProps = {
  children: ValidPropTypes.NODE
};
TabPanel.defaultProps = {
  panelId: ""
};
PanelList.displayName = "PanelList";
PanelList.propTypes = {
  children: node.isRequired
};
PanelList.requiredProps = {
  children: ValidPropTypes.NODE
};
PanelList.defaultProps = {};
Tab.displayName = "Tab";
Tab.propTypes = {
  closeFlyout: func,
  isControlled: bool,
  isDisabled: bool,
  isOverflow: bool,
  name: oneOfType([string, node]).isRequired,
  // DEPRECATED: this isn't a style in the DBG
  secondary: bool,
  setTabWidth: func,
  tabId: string.isRequired,
  onTabChange: func
};
Tab.requiredProps = {
  index: ValidPropTypes.STRING,
  name: ValidPropTypes.STRING,
  tabId: ValidPropTypes.STRING
};
Tab.defaultProps = {
  secondary: false,
  closeFlyout: function closeFlyout() {
    return void 0;
  },
  setTabWidth: function setTabWidth() {
    return void 0;
  },
  isControlled: false,
  isDisabled: false,
  isOverflow: false,
  onTabChange: null
};
TabList.displayName = "TabList";
TabList.propTypes = {
  className: string,
  hasDivider: bool,
  id: string,
  isControlled: bool,
  /** Messages for internationalization */
  messages: object,
  noDropdown: bool,
  // DEPRECATED: this isn't a style in the DBG
  secondary: bool,
  tabListRef: shape({
    current: object
  }).isRequired,
  onTabChange: func
};
TabList.requiredProps = {};
TabList.defaultProps = {
  className: "",
  hasDivider: false,
  id: null,
  isControlled: false,
  messages: {},
  noDropdown: false,
  secondary: false,
  onTabChange: null
};
TabGroup.displayName = "TabGroup";
TabGroup.propTypes = {
  children: node.isRequired,
  className: string,
  disabledTabs: arrayOf(number),
  hasDivider: bool,
  id: string,
  isControlled: bool,
  /** Messages for internationalization */
  messages: object,
  noDropdown: bool,
  // DEPRECATED: this isn't a style in the DBG
  secondary: bool,
  tabs: arrayOf(oneOfType([string, node])).isRequired,
  useAnchor: bool,
  onTabChange: func
};
TabGroup.requiredProps = {
  children: ValidPropTypes.NODE,
  tabs: ValidPropTypes.ARRAY
};
TabGroup.defaultProps = {
  className: "",
  disabledTabs: [],
  hasDivider: false,
  id: null,
  isControlled: false,
  messages: {},
  noDropdown: false,
  onTabChange: null,
  secondary: false,
  useAnchor: false
};
TabGroup.DefaultMessages = DefaultMessages;
var RawTabGroup = TabGroup;
var TabGroup$1 = makeErrorBoundComponent(RawTabGroup);
export { RawTabGroup, Tab, TabGroup$1 as TabGroup, TabList, TabPanel };
